import useTranslation from "next-translate/useTranslation";
// import FCLoginComponent from "../components/LoginComponent/FCLoginComponent";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import nookies from "nookies";
import { Suspense } from "react";

import { wrapper } from "redux/configureStore";
import { checkUser } from "utils/BackendHelper";
import HeadSeo from "../components/HeadSeo/HeadSeo";
import siteMetadata from "../data/siteMetadata";

const LoginRegisterDialog = dynamic(
  () => import("components/LoginRegisterDialog"),
  {
    ssr: false,
    suspense: true,
  }
);

export const getServerSideProps = wrapper.getServerSideProps((store) => {
  return async (ctx) => {
    return new Promise<any>(async (resolve, reject) => {
      let user: any = await checkUser(ctx, store, null);

      let recommanded_listings = [];
      const cookies = nookies.get(ctx);
      if (!user) {
        resolve({
          props: {
            checkPro: ctx.query.pro ? true : false,
            resolvedUrl: ctx.resolvedUrl,
          },
        });
      } else {
        if (ctx.query.redirect) {
          resolve({
            redirect: {
              destination: ctx.query.redirect,
              permanent: false,
            },
          });
        } else {
          if (user.isPro) {
            resolve({
              redirect: {
                destination: "/espace-pro",
                permanent: false,
              },
            });
          } else {
            resolve({
              redirect: {
                destination: "/user/estimates",
                permanent: false,
              },
            });
          }
        }
      }
    });
  };
});

const RendringPage = (props: any) => {
  const { t, lang } = useTranslation("connexionInscription");
  const router = useRouter();
  const handleRedirect = (user: any) => {
    const redirect = new URLSearchParams(window.location.search).get(
      "redirect"
    );
    if (user.isPro) {
      window.location.href = `${
        redirect ? `${redirect}` : `/${lang}/espace-pro/vitrine/gerermavitrine`
      }`;
    } else {
      window.location.href = `${
        redirect ? `${redirect}` : `/${lang}/user/estimates`
      }`;
    }
  };

  return (
    <div>
      <HeadSeo
        title={`agenz - comment réussir votre vente`}
        description={`Estimation`}
        ogImageUrl={
          "https://storage.googleapis.com/headers-agenz/Logo%20300_%20300%20px.jpg"
        }
        ogTwitterImage={siteMetadata.siteLogoSquare}
        ogType={"website"}
        ogTitle={"agenz - comment réussir votre vente"}
        ogDescription={"Estimation "}
        canonicalUrl={"https://agenz.ma/login"}
        structuredData={false}
      >
        <></>
      </HeadSeo>

      <div
        className="page-wrapper"
        style={{ paddingTop: 60, overflow: "hidden" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            overflowX: "hidden",
          }}
        >
          <div style={{ maxWidth: "min(100%, 800px)" }}>
            <Suspense fallback={<></>}>
              <LoginRegisterDialog
                visible={false}
                onClose={() => {}}
                onFacebookSignInSuccess={handleRedirect}
                onGoogleSignInSuccess={handleRedirect}
                onRegisterSucccess={handleRedirect}
                onSignInSuccess={handleRedirect}
                onSwitchSignType={() => {
                  return;
                }}
                Estimation={true}
                Register={true}
                variant="PAGE"
                defaultView="LOGIN"
                registerWithPassword={true}
              />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RendringPage;
